import { marketPlaceBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";
import {
  PaymentOrderSearchResult,
  PaymentReceiveOrderSearch,
  PaymentOrderSummaryResult,
} from "@/types/amazon/paymentOrder";

export const AmazonPaymentApi = createApi({
  reducerPath: "AmazonPaymentApi",
  baseQuery: marketPlaceBaseQueryWrapper,
  tagTypes: ["amazonPayment"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    uploadPaymentOrder: builder.mutation({
      query: ({ formData }) => ({
        url: `/amazon-payments/payments/xlsx`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["amazonPayment"],
    }),
    searchPaymentOrder: builder.query<
      PaymentOrderSearchResult,
      PaymentReceiveOrderSearch
    >({
      query: (input) => ({
        url: `/amazon-payments/paymentssearch`,
        method: "POST",
        body: { ...input, export: false },
      }),
      providesTags: ["amazonPayment"],
    }),
    exportPaymentOrders: builder.mutation<Blob, PaymentReceiveOrderSearch>({
      query: (input) => ({
        url: `/amazon-payments/paymentssearch`,
        method: "POST",
        body: { ...input, export: true },
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    summaryPaymentOrders: builder.query<
      PaymentOrderSummaryResult,
      PaymentReceiveOrderSearch
    >({
      query: (input) => ({
        url: `/amazon-payments/payment-summary`,
        method: "POST",
        body: input,
      }),
      providesTags: ["amazonPayment"],
    }),
    deletePayment: builder.mutation<void, string[]>({
      query: (ids) => ({
        url: "/amazon-payments/delete",
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["amazonPayment"],
    }),
  }),
});

export const {
  useUploadPaymentOrderMutation,
  useSearchPaymentOrderQuery,
  useLazySearchPaymentOrderQuery,
  useExportPaymentOrdersMutation,
  useSummaryPaymentOrdersQuery,
  useDeletePaymentMutation,
} = AmazonPaymentApi;
